var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ranking-board"}},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("模具上报记录数量")]),_c('dv-scroll-ranking-board',{attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }